// eslint-disable-next-line
import React, { useRef } from 'react';
import CreateRooms from '../createRoom/CreateRoom';
import { Room } from '../types';

interface CreateRoomRosterProps {
  onClose?: () => void;
  handleDrawerDirty?: (isDirty: boolean) => void;
  footerButtonLabel: string;
  hasStudents?: boolean;
}

/**
 * Needed: Since DropDownDrawerButton's Drawer uses React.cloneElement, causing components to be rerender triggering
 * useEffects whose dependencies depend on props.
 */
export function CreateRoomRoster({
  onClose,
  handleDrawerDirty,
  footerButtonLabel,
  hasStudents = true,
}: CreateRoomRosterProps) {
  const rooms = useRef<Room[]>([]);
  return (
    <CreateRooms
      onClose={onClose}
      handleDrawerDirty={handleDrawerDirty}
      footerButtonLabel={footerButtonLabel}
      // eslint-disable-next-line
      rooms={rooms.current}
      hasStudents={hasStudents}
    />
  );
}
